export default "__VITE_ASSET__CJhoeica__"